import { PRODUCT_ID_PARAM } from '../constants'

export const getTierProductIdQueryParamFromHash = () => {
  const hashQueryParams = new URLSearchParams(
    window.location.hash.replace('#cart', ''),
  )
  const productId = hashQueryParams.get(PRODUCT_ID_PARAM)
  return productId ? Number(productId) : null
}
